export function hasWebWorkerContext() {
    try {
        // @ts-ignore: importScripts may be undefined
        return typeof importScripts === "function";
    }
    catch (err) {
        return false;
    }
}
//# sourceMappingURL=hasWebWorkerContext.js.map